export default __webpack_public_path__ + "static/media/vangskyrkja.4b6bbac2.jpg";